import React, { useCallback, useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress'
import WarningModal from '../components/modal'

interface PayoutsProps {
  type: string;
  phoneNumber: string;
  amount: string;
  accNo?: string;
  ifsc?: string;
  user?: string;
  membershipID?: string;
  handleToUpdateStatus: Function;
  coupon?: string;
  prevBankUUID: Array<any>;
  dealerDetails?: any;
  questionType?: any;
  bonusAmount?: string;
  promoCode: string;
  promoAmt: string;
}

export const Payouts: React.FC<PayoutsProps> = (props: PayoutsProps) => {

  const [loading, setLoading] = useState(false)
  const [locationBlocked, setLocationBlocked] = useState(false)

  const {
    handleToUpdateStatus, phoneNumber, amount, type, accNo, ifsc, user, membershipID, coupon, prevBankUUID,
    dealerDetails, questionType, bonusAmount, promoCode, promoAmt
  } = props;

  const axios = require('axios').default;

  const HOST = process.env.REACT_APP_HOST;
  const API = process.env.REACT_APP_API;
  const REACT_APP_AZURE_HOST_PAYTM_PROD = process.env.REACT_APP_AZURE_HOST_PAYTM_PROD;
  const REACT_APP_AZURE_HOST_PAYTM_UAT = process.env.REACT_APP_AZURE_HOST_PAYTM_UAT;
  const REACT_APP_AZURE_HOST_BANK_PROD = process.env.REACT_APP_AZURE_HOST_BANK_PROD;
  const REACT_APP_AZURE_HOST_BANK_UAT = process.env.REACT_APP_AZURE_HOST_BANK_UAT;

  const path = window.location.pathname;
  const pathParams = path.split('/')
  const isForPtr = pathParams[1].toLowerCase() === 'ptr'
  const product = isForPtr ? pathParams[2] : pathParams[1]
  const message = 'Something went wrong. Please Retry.'

  const heading = "Location Disabled !!"
  const content = "Please allow location permissions to continue"


  const statusCheck = async (code: any, message: string, orderId: string, razor_transaction_id?: string) => {

    if (code === 'DE_001') {
      handleToUpdateStatus('SUCCESS', "success", orderId, '-');
    }
    else if (code === 'DE_101' || code === 'DE_102') {
      handleToUpdateStatus('PENDING', message, orderId, '-');
    }
    else if (code === 'processed' || code === 'SUCCESS') {
      handleToUpdateStatus('SUCCESS', "success", orderId, razor_transaction_id);
    }
    else if (code === 'queued' || code === 'pending' || code === 'processing' || code === 'APPROVAL_PENDING'
      || code === 'PENDING' || code === 'QUEUED' || code === 'RECEIVED') {
      handleToUpdateStatus('PENDING', message, orderId, razor_transaction_id);
    }
    else if (code === 'rejected' || code === 'cancelled' || code === 'reversed' || code === 'FAILED'
      || code === 'MANUALLY_REJECTED' || code === 'REJECTED' || code === 'REVERSED') {
      handleToUpdateStatus('FAILURE', message, orderId, razor_transaction_id);
    }
    else {
      return handleToUpdateStatus('FAILURE', message, orderId, '-');
    }
  }

  const initiateWalletTransaction = async (a: any, b: any, pincode: any, city: any) => {
    setLoading(true);
    axios
      .post(`${REACT_APP_AZURE_HOST_PAYTM_PROD}`, {
        phoneNumber: questionType === "Dealer" ? dealerDetails.dealerMobile : (localStorage.getItem('phone_number') || localStorage.getItem('contractor_phone')),
        amount: amount,
        coupon: coupon,
        membershipId: membershipID,
        userType: user,
        user_latitude: a,
        user_longitude: b,
        user_pincode: pincode,
        user_city: city,
        product: product,
        dealer_name: dealerDetails?.dealerName || localStorage.getItem('dealer_name') || "",
        dealer_mobile: dealerDetails?.dealerMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('phone_number') : '') || '',
        contractor_name: dealerDetails?.contractorName || 'test',
        contractor_mobile: dealerDetails?.contractorMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number')) || "",
        question_type: questionType && questionType,
        bonus_amount: bonusAmount,
        promo_code: promoCode,
        promo_amount: promoAmt
      },
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
      .then((response: any) => {
        setLoading(false);
        const data = response.data.data
        statusCheck(data.statusCode, data.statusMessage, response.data.orderId)
      })
      .catch((err: any) => {
        var dispMess = err.response;
        setLoading(false);
        if (dispMess.status === 400) {
          if (dispMess.data.message) {
            handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
          }
          else {
            handleToUpdateStatus('FAILURE', message, '-', '-')
          }
        }
        else {
          handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-')
        }
      });
  }

  const initiateBankTransaction = async (a: any, b: any, pincode: any, city: any) => {
    setLoading(true);
    return axios
      .post(`${HOST}${API}initiate-cashfree-bank-transaction/`,
        prevBankUUID[1] === "from_old_bank" ? {
          phoneNumber: questionType === "Dealer" ? dealerDetails.dealerMobile : (localStorage.getItem('phone_number') || localStorage.getItem('contractor_phone')),
          amount: amount,
          coupon: coupon,
          membershipId: membershipID,
          userType: user,
          user_latitude: a,
          user_longitude: b,
          user_pincode: pincode,
          user_city: city,
          product: product,
          from_old_bank: prevBankUUID[1] === "from_old_bank" && true,
          bank_uuid: prevBankUUID[0],
          dealer_name: dealerDetails?.dealerName || localStorage.getItem('dealer_name') || "",
          dealer_mobile: dealerDetails?.dealerMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('phone_number') : '') || '',
          contractor_name: dealerDetails?.contractorName || 'test',
          contractor_mobile: dealerDetails?.contractorMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number')) || '',
          question_type: questionType && questionType,
          is_bank: true,
          beneficiaryName: "test",
          bonus_amount: bonusAmount,
          promo_code: promoCode,
          promo_amount: promoAmt
        } :
          {
            phoneNumber: questionType === "Dealer" ? dealerDetails.dealerMobile : (localStorage.getItem('phone_number') || localStorage.getItem('contractor_phone')),
            amount: amount,
            ifsc: ifsc,
            accountNumber: accNo,
            coupon: coupon,
            membershipId: membershipID,
            userType: user,
            user_latitude: a,
            user_longitude: b,
            user_pincode: pincode,
            user_city: city,
            product: product,
            dealer_name: dealerDetails?.dealerName || localStorage.getItem('dealer_name') || "",
            dealer_mobile: dealerDetails?.dealerMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('phone_number') : '') || '',
            contractor_name: dealerDetails?.contractorName || 'test',
            contractor_mobile: dealerDetails?.contractorMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number')) || '',
            question_type: questionType && questionType,
            is_bank: true,
            beneficiaryName: "test",
            bonus_amount: bonusAmount,
            promo_code: promoCode,
            promo_amount: promoAmt
          },
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
      .then((response: any) => {
        setLoading(false);
        const data = response.data.data
        statusCheck(data.status, data.status_description, data.transfer_id, data.cf_transfer_id)
      })
      .catch((err: any) => {
        var dispMess = err.response;
        setLoading(false);
        if (dispMess.status === 400) {
          if (dispMess.data.message) {
            handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
          }
          else {
            handleToUpdateStatus('FAILURE', message, '-', '-') //HANDLE INVALID IFSC
          }
        }
        else {
          handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-')
        }
      });
  }

  const initiatePointsTransaction = async (a: any, b: any, pincode: any, city: any) => { //change body  
    setLoading(true);
    return axios
      .post(`${HOST}${API}initiate-points-transaction/`, {
        phoneNumber: questionType === "Dealer" ? phoneNumber : (localStorage.getItem('phone_number') || localStorage.getItem('contractor_phone')),
        membershipId: membershipID,
        coupon: coupon,
        amount: amount,
        user: user,
        user_latitude: a,
        user_longitude: b,
        user_pincode: pincode,
        user_city: city,
        product: product,
        dealer_name: dealerDetails?.dealerName || localStorage.getItem('dealer_name') || "",
        dealer_mobile: dealerDetails?.dealerMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('phone_number') : '') || '',
        contractor_name: dealerDetails?.contractorName || 'test',
        contractor_mobile: dealerDetails?.contractorMobile || (localStorage.getItem('IS_DEALER_LOGIN') === 'yes' ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number')) || '',
        question_type: questionType && questionType,
        bonus_amount: bonusAmount,
        promo_code: promoCode,
        promo_amount: promoAmt
      },
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
      .then((response: any) => {
        setLoading(false);
        const data = response.data.data.data[0]

        if (response.data.data.data[0].resultCode === "0") {
          handleToUpdateStatus("SUCCESS", "success", response.data.orderId, '-')
        }
        else {
          handleToUpdateStatus("FAILURE", data.resultDescription, response.data.orderId, '-')
        }
      })
      .catch((err: any) => {
        var dispMess = err.response;
        setLoading(false);
        if (dispMess.status === 400) {
          if (dispMess.data.message) {
            handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
          }
          else {
            handleToUpdateStatus('FAILURE', message, '-', '-')
          }
        }
        else {
          handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-')
        }
      });
  }

  const triggerPayment = (latitude: any, longitude: any, pincode: any, city: any) => {
    switch (type) {
      case 'wallet':
        initiateWalletTransaction(latitude, longitude, pincode, city);
        break;
      case 'bank':
        initiateBankTransaction(latitude, longitude, pincode, city);
        break;
      case 'points':
        initiatePointsTransaction(latitude, longitude, pincode, city);
        break;
      default:
        console.error('Invalid transaction type');
    }
  };

  useEffect(() => {
    if (!['wallet', 'bank', 'points'].includes(type)) return;
    setLoading(true);
    const geocoder = new google.maps.Geocoder();

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        const latlng = new google.maps.LatLng(latitude, longitude);

        geocoder.geocode({ 'location': latlng }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK && results[0]) {
            let pincode, city;
            for (let component of results[0].address_components) {
              if (component.types[0] === 'postal_code') {
                pincode = component.long_name;
              }
              if (component.types[0] === 'locality') {
                city = component.long_name;
              }
            }
            triggerPayment(latitude, longitude, pincode, city);
          }
        });
      },
      () => {
        const storedDealerInfo = localStorage.getItem('dealer_info');
        const dealerData = storedDealerInfo && JSON.parse(storedDealerInfo);

        if (dealerDetails || (dealerData && localStorage.getItem('IS_DEALER_LOGIN'))) {
          triggerPayment(
            dealerDetails?.dealerLatitude || dealerData?.dealerlatitude_c || '12.12345', 
            dealerDetails?.dealerLongitude || dealerData?.dealerlongitude_c || '12.12345', 
            dealerDetails?.pincode || dealerDetails?.dealerpin_c || '', 
            ''
          );
        } else {
          setLocationBlocked(true);
        }
      }
    );
    setLoading(false);
  }, []);

  return (
    <div>
      {
        loading &&
        <CircularProgress />
      }
      {
        locationBlocked && <WarningModal heading={heading} content={content} isOpen={locationBlocked}/>
      }
    </div>
  );
}

export default Payouts;